<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="40%"
    class="addEditDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="documentPermissionForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24" v-if="configType === 1">
          <el-form-item label="申请部门" prop="deptCode">
            <el-select
              clearable
              v-model="formData.deptCode"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="applyDeptRemoteMethod"
              @change="applyDeptChange"
              :loading="applyDeptLoading"
            >
              <el-option v-for="item in applyDeptList" :key="item.deptCode" :label="item.deptName" :value="item.deptCode" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="configType === 2">
          <el-form-item label="费用归属部门" prop="expensesDeptCode">
            <el-select v-model="formData.expensesDeptCode" filterable placeholder="请选择">
              <el-option
                v-for="item in expensesDeptList"
                :key="item.expeDeptCode"
                :label="item.expeDeptName"
                :value="item.expeDeptCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="configType === 3">
          <el-form-item label="活动申请人" prop="applyUserId">
            <el-select
              clearable
              v-model="formData.applyUserId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="applyUserRemoteMethod"
              @change="applyUserChange"
              :loading="userLoading"
            >
              <el-option v-for="item in applyUserList" :key="item.userId" :label="item.combination" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="configType === 4">
          <el-form-item label="活动单号" prop="activityCode">
            <el-input v-model="formData.activityCode" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="查看人" prop="userId">
            <el-select
              clearable
              v-model="formData.userId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              @change="userChange"
              :loading="userLoading"
            >
              <el-option v-for="item in userList" :key="item.userId" :label="item.combination" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  expensesJurManagementApi,
  transferOrderApi,
  documentViewPermissionApi,
  approvalManagementApi
} from '../../service';
import { arrayQuery } from '@/utils/utils';

export default {
  data () {
    return {
      rules: {
        deptCode: [
          { required: true, message: '请选择申请部门', trigger: 'change' }
        ],
        expensesDeptCode: [
          { required: true, message: '请选择费用归属部门', trigger: 'change' }
        ],
        applyUserId: [
          { required: true, message: '请选择活动申请人', trigger: 'change' }
        ],
        activityCode: [
          { required: true, message: '请输入活动单号', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '请选择查看人', trigger: 'change' }
        ]
      },
      dialogTitle: '添加',
      formData: {},
      applyDeptList: [],
      expensesDeptList: [],
      userList: [],
      applyUserList: [],
      dialogVisible: false,
      userLoading: false,
      applyDeptLoading: false
    };
  },
  props: {
    addEditDialogShow: {
      type: Boolean,
      default: false
    },
    configType: {
      type: Number,
      default: 1
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    addEditDialogShow (val) {
      if (val) {
        this.dialogTitle = this.rowData.id ? '编辑' : '添加';
        if (this.rowData.id) {
          this.formData = this.rowData;
          this.remoteMethod(this.formData.userName);
          if (this.configType === 1) this.applyDeptRemoteMethod(this.formData.deptName);
          if (this.configType === 3) this.applyUserRemoteMethod(this.formData.applyUserName);
        }
        this.getExpensesDeptList();
      } else {
        this.formData = {};
        this.$nextTick(() => {
          this.$refs.documentPermissionForm.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    userChange (val) {
      this.formData.userName = arrayQuery(val, this.userList, 'userId').userName;
    },
    applyUserChange (val) {
      this.formData.applyUserName = arrayQuery(val, this.applyUserList, 'userId').userName;
    },
    applyDeptChange (val) {
      this.formData.deptName = arrayQuery(val, this.applyDeptList, 'deptCode').deptName;
    },
    applyDeptRemoteMethod (query) {
      if (query && query.indexOf(' ') === -1) {
        let params = {
          type: 'APPLAY',
          key: query
        };
        this.applyDeptLoading = true;
        approvalManagementApi.getDeptList(params).then(res => {
          if (res.status === '200') {
            this.applyDeptList = res.data;
          }
          this.applyDeptLoading = false;
        });
      }
    },
    async remoteMethod (query) {
      if (query && query.indexOf(' ') === -1) {
        this.userLoading = true;
        this.userList = await this.getPersonnelList(query);
        this.userLoading = false;
      }
    },
    async applyUserRemoteMethod (query) {
      if (query && query.indexOf(' ') === -1) {
        this.userLoading = true;
        this.applyUserList = await this.getPersonnelList(query);
        this.userLoading = false;
      }
    },
    getPersonnelList (query) {
      return new Promise((resolve, reject) => {
        transferOrderApi.getAllSalesmanList(query).then(res => {
          if (res.status === '200') {
            let userList = [];
            if (res.data && res.data.length > 0) {
              userList = res.data.map(item => {
                return {
                  ...item,
                  combination: `${item.userName}/${item.deptName}`
                };
              });
            }
            resolve(userList);
          }
        });
      });
    },
    submitHandlen () {
      this.$refs['documentPermissionForm'].validate((valid) => {
        if (valid) {
          let params = {
            userId: this.formData.userId,
            userName: this.formData.userName
          };
          if (this.formData.id) {
            params.id = this.formData.id;
          }
          switch (this.configType) {
            case 1:
              params.visibleDeptType = '申请部门';
              params.deptCode = this.formData.deptCode;
              params.deptName = this.formData.deptName;
              this.deptSubmitHandler(params);
              break;
            case 2:
              params.visibleDeptType = '费用归属部门';
              params.deptCode = this.formData.expensesDeptCode;
              params.deptName = arrayQuery(this.formData.expensesDeptCode, this.expensesDeptList, 'expeDeptCode').expeDeptName;
              this.deptSubmitHandler(params);
              break;
            case 3:
              params.type = '1';
              params.applyUserId = this.formData.applyUserId;
              params.applyUserName = this.formData.applyUserName;
              this.userSubmitHandler(params);
              break;
            default:
              params.type = '2';
              params.activityCode = this.formData.activityCode;
              this.userSubmitHandler(params);
          }
        }
      });
    },
    deptSubmitHandler (params) {
      this.$store.commit('setSubPageLoading', true);
      if (params.id) {
        documentViewPermissionApi.visibleDeptEdit(params).then(res => {
          if (res.status === '200') {
            this.$message.success('编辑成功');
            this.$emit('subSuccessHandler');
          }
          this.$store.commit('setSubPageLoading', false);
        });
      } else {
        documentViewPermissionApi.visibleDeptAdd(params).then(res => {
          if (res.status === '200') {
            this.$message.success('添加成功');
            this.$emit('subSuccessHandler');
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }
    },
    userSubmitHandler (params) {
      this.$store.commit('setSubPageLoading', true);
      if (params.id) {
        documentViewPermissionApi.visibleUserEdit(params).then(res => {
          if (res.status === '200') {
            this.$message.success('编辑成功');
            this.$emit('subSuccessHandler');
          }
          this.$store.commit('setSubPageLoading', false);
        });
      } else {
        documentViewPermissionApi.visibleUserAdd(params).then(res => {
          if (res.status === '200') {
            this.$message.success('添加成功');
            this.$emit('subSuccessHandler');
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }
    },
    dialogCloseHandle () {
      this.$emit('dialogClose');
    },
    getExpensesDeptList () {
      expensesJurManagementApi.getExpenseDeptList().then(res => {
        if (res.status === '200') {
          this.expensesDeptList = res.data;
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
